<template>
  <div class="col-lg-12 col-xs-12 listing">
    <div class="row">
      <div class="col-md-3 col-xs-12">
        <p class="font-weight-bold" v-translate>Email Notification</p>
        <p class="text-muted">
          <span v-translate
            >We will send you email updates regarding the service.</span
          >
        </p>
      </div>
      <div class="col-md-9 col-xs-12">
        <div class="row mb-4" v-if="$session.get('company_id') === 1">
          <div class="col my-auto">
            <p class="font-weight-bold pb-1 mb-0">{{ t('Weekly Report') }}</p>
            <span class="text-muted">{{
              t('Summary of your website for the past week.')
            }}</span>
          </div>
          <div class="col-md-2 ml-auto text-right">
            <toggle-button
              class="mt-1"
              v-model="notification_weekly"
              :value="notification_weekly"
              :sync="true"
              color="#2eb15a"
              :labels="true"
              :disabled="Number($session.get('user_id')) === 2572"
              @change="
                updateStatus({
                  id: $session.get('user_id'),
                  subject: 'weekly',
                  status: notification_weekly,
                })
              "
            />
          </div>
        </div>
        <div class="row mb-4">
          <div class="col my-auto">
            <p class="font-weight-bold pb-1 mb-0">{{ t('Weekly Experiment Report') }}</p>
            <span class="text-muted">{{
              t('Summary of your experiment(s) for the past week.')
            }}</span>
          </div>
          <div class="col-md-2 ml-auto text-right">
            <toggle-button
              class="mt-1"
              v-model="notification_experiment_weekly"
              :value="notification_experiment_weekly"
              :sync="true"
              color="#2eb15a"
              :labels="true"
              :disabled="Number($session.get('user_id')) === 2572"
              @change="
                updateStatus({
                  id: $session.get('user_id'),
                  subject: 'experiment_weekly',
                  status: notification_experiment_weekly,
                })
              "
            />
          </div>
        </div>
        <!-- <div class="row mb-4">
          <div class="col my-auto">
            <p class="font-weight-bold pb-1 mb-0">Recording</p>
            <span class="text-muted">Daily notification of new Heatmap and Recording sessions.</span>
          </div>
          <div class="col-md-2 ml-auto text-right">
            <toggle-button
              class="mt-1"
              v-model="notification_recording"
              :value="notification_recording"
              :sync="true"
              color="#2eb15a"
              :labels="true"
                      :disabled="Number($session.get('user_id')) === 2572"

              @change="updateStatus({
              id: $session.get('user_id'),
              subject: 'recording',
              status: notification_recording
            })"
            />
          </div>
        </div> -->
        <div class="row mb-4" v-if="$session.get('company_id') === 1">
          <div class="col my-auto">
            <p class="font-weight-bold pb-1 mb-0">{{ t('Onboarding tips') }}</p>
            <span class="text-muted">{{
              t(
                'Send you tips and use case of how you can fully utilize on our product and features.'
              )
            }}</span>
          </div>
          <div class="col-md-2 ml-auto text-right">
            <toggle-button
              class="mt-1"
              v-model="notification_onboard"
              :value="notification_onboard"
              :sync="true"
              color="#2eb15a"
              :labels="true"
              :disabled="Number($session.get('user_id')) === 2572"
              @change="
                updateStatus({
                  id: $session.get('user_id'),
                  subject: 'onboard',
                  status: notification_onboard,
                })
              "
            />
          </div>
        </div>
        <div class="row mb-4" v-if="$session.get('company_id') === 1">
          <div class="col my-auto">
            <p class="font-weight-bold pb-1 mb-0">
              {{ t('Error notification') }}
            </p>
            <span class="text-muted">{{
              t(
                'We will send you a list of javascript error occurance detected from your website.'
              )
            }}</span>
          </div>
          <div class="col-md-2 ml-auto text-right">
            <toggle-button
              class="mt-1"
              v-model="notification_error"
              :value="notification_error"
              :sync="true"
              color="#2eb15a"
              :labels="true"
              :disabled="Number($session.get('user_id')) === 2572"
              @change="
                updateStatus({
                  id: $session.get('user_id'),
                  subject: 'error',
                  status: notification_error,
                })
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'

export default {
  components: {},
  store,
  data: function () {
    return {
      company_id: this.$session.get('company_id'),
      team: null,
      notification_weekly: true,
      notification_recording: true,
      notification_onboard: true,
      notification_error: true,
      notification_onboard: true,
      notification_experiment_weekly: true,
    }
  },
  filters: {},
  methods: {
    updateStatus(data) {
      this.$http
        .post(process.env.API_ENDPOINT + '/notification/status', {
          subject: data.subject,
          user_id: data.id,
          status: data.status,
        })
        .then((response) => {})
    },
    initiate() {
      this.$http
        .get(
          process.env.API_ENDPOINT +
            '/notification/' +
            this.$session.get('user_id')
        )
        .then((response) => {
          let data = response.data
          this.notification_weekly = data[0].notification_weekly
          this.notification_recording = data[0].notification_recording
          this.notification_onboard = data[0].notification_onboard
          this.notification_error = data[0].notification_error
          this.notification_experiment_weekly = data[0].notification_experiment_weekly
        })
    },
  },
  mounted() {},
  beforeMount() {
    this.initiate()
  },
}
</script>
<style>
.role {
  padding: 5px 10px;
  font-weight: normal;
  border-radius: 4px;
  -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
    0 1px 3px rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.admin {
  background-color: #2c68eb;
  color: white;
}

.viewer {
  background-color: #eef2fb;
}
</style>


// WEBPACK FOOTER //
// src/pages/NotificationSetting.vue